// extracted by mini-css-extract-plugin
export var bannerContainer = "banner-module--banner-container--886d3";
export var container = "banner-module--container--4056a";